import axios from "axios";
import { API_CLIENTS_URL } from "../utils/constants";
import { handleServiceError } from "../utils/helpers";

export const getClientsByPhoneOrName = async (
    size: number = 10,
    page: number = 0,
    sort: string = "createdAt,asc",
    searchByFullName?: string,
    searchByPhone?: string,
) => {
    const token = localStorage.getItem("access_token");
    try {
        const byFullNameParam = searchByFullName ? `&searchByFullName=${searchByFullName}` : "";
        const byPhoneParam = searchByPhone ? `&searchByPhone=${searchByPhone}` : "";
        const response = await axios.get(
            `${API_CLIENTS_URL}?page=${page}&size=${size}&sort=${sort}${byFullNameParam}${byPhoneParam}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getClientsBySearchQuery = async (
    size: number = 10,
    page: number = 0,
    sort: string = "createdAt,asc",
    searchQuery?: string,
) => {
    const token = localStorage.getItem("access_token");
    try {
        const byFullNameParam = searchQuery ? `&query=${searchQuery}` : "";
        const response = await axios.get(
            `${API_CLIENTS_URL}/search?page=${page}&size=${size}&sort=${sort}${byFullNameParam}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getClientAddressesByClientId = async (
    size: number = 10,
    page: number = 0,
    sort: string = "createdAt,asc",
    clientId: string,
) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.get(
            `${API_CLIENTS_URL}/${clientId}/addresses?page=${page}&size=${size}&sort=${sort}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
}
